import { NgModule } from '@angular/core';
import { provideLazyLoad } from '@core/jss-utils';
import { ReviewEntrySectionContainerComponent } from '@reviews/lazy';

import { AccordionContainerComponent } from './accordion-container/accordion-container.component';
import { ContactSectionContainerComponent } from './contact-section-container/contact-section-container.component';
import { ContentFourTopTasksContainerComponent } from './content-four-top-tasks-container/content-four-top-tasks-container.component';
import { ContentSectionTextContainerComponent } from './content-section-text-container/content-section-text-container.component';
import { ContentThreeTopTasksContainerComponent } from './content-three-top-tasks-container/content-three-top-tasks-container.component';
import { ExtendedUspsContainerComponent } from './extended-usps-container/extended-usps.container.component';
import { FunnelContentContainerComponent } from './funnel-content-container/funnel-content.container.component';
import { GenericFormContainerComponent } from './generic-form-container/generic-form-container.component';
import { GenericProductsContainerComponent } from './generic-products-container/generic-products-container.component';
import { HeroContainerComponent } from './hero-container/hero-container.component';
import { InformationCardRowContainerComponent } from './infocard-row-container/information-card-row.container.component';
import { LinkListContainerComponent } from './link-list-container/link-list.container.component';
import { LogosSectionContainerComponent } from './logos-section-container/logos-section-container.component';
import { NotificationContainerComponent } from './notification-container/notification-container.component';
import { ProductCardSectionContainerComponent } from './product-card-section-container/product-card-section.container.component';
import { SimpleUspContainerComponent } from './simple-usp-container/simple-usp.container.component';
import { StepsSectionContainerComponent } from './steps-section-container/steps-section.container.component';
import { TextImageContainerComponent } from './text-image-container/text-image.container.component';
import { VideoContainerComponent } from './video-container/video.container.component';
import { SimpleTableContainerComponent } from './simple-table-container/simple-table.container.component';
import { TextWidgetContainerComponent } from './text-widget-container/text-widget.container.component';

@NgModule({
  imports: [
    provideLazyLoad({
      AccordionSection: AccordionContainerComponent,
      ContactSection: ContactSectionContainerComponent,
      ExtendedUsps3Section: ExtendedUspsContainerComponent,
      ExtendedUsps4Section: ExtendedUspsContainerComponent,
      FaqSection: AccordionContainerComponent,
      FourTopTasksSection: ContentFourTopTasksContainerComponent,
      FunnelContentSection: FunnelContentContainerComponent,
      GenericFormSection: GenericFormContainerComponent,
      GenericProductsSection: GenericProductsContainerComponent,
      Hero: HeroContainerComponent,
      HeroMinimal: HeroContainerComponent,
      HeroWithAppButtons: HeroContainerComponent,
      HeroWithAsset: HeroContainerComponent,
      HeroWithWidget: HeroContainerComponent,
      InformationCard2Section: InformationCardRowContainerComponent,
      InformationCard3Section: InformationCardRowContainerComponent,
      InformationCard4Section: InformationCardRowContainerComponent,
      LinkList2Section: LinkListContainerComponent,
      LinkList3Section: LinkListContainerComponent,
      LinkList6Section: LinkListContainerComponent,
      LogosSection: LogosSectionContainerComponent,
      ReviewEntrySectionAside: ReviewEntrySectionContainerComponent,
      NotificationSection: NotificationContainerComponent,
      SimpleUspSection: SimpleUspContainerComponent,
      StepsSection: StepsSectionContainerComponent,
      TextDefault: ContentSectionTextContainerComponent,
      TextDefaultAside: ContentSectionTextContainerComponent,
      TextImageSection: TextImageContainerComponent,
      ProductCard2Section: ProductCardSectionContainerComponent,
      ProductCard3Section: ProductCardSectionContainerComponent,
      TextImageAppSection: TextImageContainerComponent,
      TextWidgetSection: TextWidgetContainerComponent,
      TextWithAppStoreButtons: ContentSectionTextContainerComponent,
      TextWithCallToActionButton: ContentSectionTextContainerComponent,
      ThreeTopTasksSection: ContentThreeTopTasksContainerComponent,
      VideoSection: VideoContainerComponent,
      SimpleTable: SimpleTableContainerComponent,
    }),
  ],
})
export class ContentLazyModule {}
